import request from './config';

export default request;
